<template>
  <page>
    <template slot="content">
      <help-content :title="'参加中の複数のイベントを見る方法'">
        <template slot="content">
          <div class="text">
            イベントは主催者ごとのグループに表示されます。<br><br>
            左スライドメニューからグループを切り替えることで参加中のイベントを確認することができます。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help36.vue